const $ = require('jquery')
const FingerprintJS = require('@fingerprintjs/fingerprintjs')
const _ = require('lodash')

const metrics = {
  url: window.location.href,
  formOpenTime: $('.itbl-c-sidebar.is-open').length ? new Date() : null,
  formSubmitTime: null,
  pageOpenTime: new Date(),
  deviceType: window.innerWidth < 769 ? 'mobile' : 'desktop',
  touchStartCount: 0,
  touchEndCount: 0,
  touchMoveDistance: 0,
  touchCancelCount: 0,
  mouseDistance: 0,
  mouseDownCount: 0,
  mouseUpCount: 0,
  keyDownCount: 0,
  keyUpCount: 0,
  visitorId: null,
  munchkinCookie: null,
  timeElapsed: null,
  mouseDistance2: null,
  email: null
}

const fieldNameMap = {
  url: 'entry.964365643',
  formOpenTime: 'entry.186114843',
  formSubmitTime: 'entry.1046616484',
  pageOpenTime: 'entry.1029991541',
  deviceType: 'entry.2099806239',
  touchStartCount: 'entry.418318467',
  touchEndCount: 'entry.1352331307',
  touchMoveDistance: 'entry.566956890',
  touchCancelCount: 'entry.1288956511',
  mouseDistance: 'entry.45680711',
  mouseDownCount: 'entry.270060443',
  mouseUpCount: 'entry.892982638',
  keyDownCount: 'entry.316672449',
  keyUpCount: 'entry.1094137667',
  visitorId: 'entry.1821330349',
  munchkinCookie: 'entry.684280368',
  timeElapsed: 'entry.1441961993',
  mouseDistance2: 'entry.15571164',
  email: 'entry.1309353636'
}

FingerprintJS.load({ monitoring: false })
  .then(fp => fp.get())
  .then(result => { metrics.visitorId = result.visitorId })

$(document).ready(() => {
  const $sidebarTriggers = $('[data-open=itbl-sidebar-right]')

  let lastTouchPosition = null
  let lastMousePosition = null

  $sidebarTriggers.on('click', () => { metrics.formOpenTime = new Date() })
  $(window).on('touchstart', e => {
    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
    lastTouchPosition = { x: touch.clientX, y: touch.clientY }
    metrics.touchStartCount++
  })
  $(window).on('touchend', () => {
    lastTouchPosition = null
    metrics.touchEndCount++
  })
  $(window).on('touchmove', _.throttle(e => {
    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
    if (lastTouchPosition)
      metrics.touchMoveDistance += Math.sqrt(Math.pow(lastTouchPosition.x - touch.clientX, 2) + Math.pow(lastTouchPosition.y - touch.clientY, 2))
    lastTouchPosition = { x: touch.clientX, y: touch.clientY }
  }, 100))
  $(window).on('touchcancel', () => { metrics.touchCancelCount++ })
  $(window).on('mousemove', _.throttle(e => {
    if (lastMousePosition)
      metrics.mouseDistance += Math.sqrt(Math.pow(lastMousePosition.x - e.clientX, 2) + Math.pow(lastMousePosition.y - e.clientY, 2))
    lastMousePosition = { x: e.clientX, y: e.clientY }
  }, 100))
  $(window).on('mousedown', () => { metrics.mouseDownCount++ })
  $(window).on('mouseup', () => { metrics.mouseUpCount++ })
  $(window).on('keydown', () => { metrics.keyDownCount++ })
  $(window).on('keyup', () => { metrics.keyUpCount++ })
})

module.exports = {
  getMetrics: () => metrics,
  submitMetrics: async (munchkinCookie, email) => await fetch('https://docs.google.com/forms/d/e/1FAIpQLScS_bxLGJOQxeIKJd_ONrtBhY7_lOVFKX9KwD1-zAJfqz10vA/formResponse', {
    method: 'POST',
    body: new URLSearchParams(Object.entries(metrics).reduce((sum, [key, value]) => {
      const newKey = fieldNameMap[key]
      if (key === 'munchkinCookie') sum[newKey] = munchkinCookie
      else if (key === 'email') sum[newKey] = email
      else if (key === 'formSubmitTime') sum[newKey] = new Date().toISOString()
      else sum[newKey] = value instanceof Date ? value.toISOString() : value
      return sum
    }, {}))
  })
}
